import styled from "styled-components";
import RolesList from "./RolesList";
import { useState } from "react";
import { useAxios } from "../../../../../axiosProvider";
import { useFetchEntities } from "../../../../../reactQueryHooks";
import AddRoleModal from "./AddRoleModal";
import { Button } from "@mui/material";

//-----------------------------------------------------------------------

const Container = styled.div`
  display: flex;
  flex: 1 0 450px;
  max-height: 500px;
  flex-direction: column;
  gap: 7px;
  background-color: white;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  padding: 7px;
  border-radius: 5px;
  user-select: none;
  width: 100%;
  height: 100%;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 7px;
  overflow-y: auto;
  position: relative;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: rgb(35, 139, 243);
`;

const AddButtonContainer = styled.div`
  width: 100%;
  min-height: 40px;
  border-radius: 5px;
`;

//-----------------------------------------------------------------------

const RolesOptions = () => {
  const { data: entities } = useFetchEntities();
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});

  const { user } = useAxios();
  const userIsPermittedToEdit =
    user.isAdmin || (user.isModerator && user.permissions.addRoles);

  const roles = entities?.data?.roles || [];

  return (
    <Container>
      <TitleContainer>Staff Roles</TitleContainer>
      <ContentContainer>
        {entities?.data && (
          <RolesList
            data={roles}
            onSelect={(item) => {
              if (userIsPermittedToEdit) {
                setData(item);
                setShowModal(true);
              } else {
                alert("You have no permission to edit roles");
              }
            }}
          />
        )}
        <AddButtonContainer>
          <Button
            sx={{
              width: "100%",
            }}
            variant="outlined"
            color="success"
            onClick={() => {
              if (userIsPermittedToEdit) {
                setShowModal(true);
                setData({});
              } else {
                alert("You have no permission to add new roles");
              }
            }}
            title="Add Role"
          >
            Add Role
          </Button>
        </AddButtonContainer>
      </ContentContainer>
      {showModal && (
        <AddRoleModal close={() => setShowModal(false)} data={data} />
      )}
    </Container>
  );
};

export default RolesOptions;
